import { Spinner } from "../spinner/Spinner.js";
import styles from "./Button.module.css";

interface ButtonProps {
  theme?: Component.Button.Theme;
  type?: Component.Button.Type;
  size?: Component.Button.Size;
  children: React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: TypeAny;
  [key: string]: TypeAny;
}

export function Button({
  onClick = () => null,
  isLoading = false,
  disabled = false,
  type = "button",
  children,
  theme,
  size,
  ...rest
}: ButtonProps) {
  return (
    <button
      disabled={isLoading || disabled}
      data-is-loading={isLoading}
      className={styles.button}
      data-theme={theme}
      onClick={onClick}
      data-size={size}
      type={type}
      {...rest}
    >
      {isLoading && (
        <div className={styles.buttonLoader} role="status">
          <Spinner />
        </div>
      )}

      {children}
    </button>
  );
}
